var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("Navbar"),
      _c(
        "div",
        { staticClass: "step-page application-record" },
        [
          _vm.showRecord
            ? [
                _c(
                  "perfect-scrollbar",
                  { staticClass: "progress-job-list" },
                  _vm._l(_vm.recordList, function (record) {
                    return _c(
                      "div",
                      {
                        key: record.index,
                        staticClass: "job-item",
                        class: {
                          active: record.MatchId === _vm.selectedDemandMatchId,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showApplicationRecord(record.MatchId)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "info" }, [
                          _c("div", { staticClass: "job-name" }, [
                            _vm._v(_vm._s(record.ManpowerDemandName)),
                          ]),
                          _c("div", { staticClass: "d-number" }, [
                            _vm._v(_vm._s(record.ManpowerDemandNo)),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm.showProgress
                  ? _c("section", { staticClass: "timeline" }, [
                      _c(
                        "ul",
                        [
                          _vm._m(0),
                          _vm._l(_vm.jobHistoryList, function (history) {
                            return _c("li", { key: history.index }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    { staticClass: "icon-wrap" },
                                    [
                                      _c("eva-icon", {
                                        attrs: {
                                          fill: "#FFF",
                                          name: "pricetags-outline",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  history.TypeName === "WriteResume"
                                    ? [
                                        _vm._m(1, true),
                                        _c(
                                          "div",
                                          { staticClass: "note-wrap" },
                                          [
                                            _vm._v(
                                              " 歡迎隨時更新個人履歷資料，祝面試順利。 "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  history.TypeName === "InterviewInvitation"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "time-wrap" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(history.OccurDate) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "text-wrap" },
                                          [_vm._v("等待面試")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "note-wrap" },
                                          [
                                            _vm._v(
                                              " 誠摯邀請您來參加本公司面試，請點選下方按鈕檢視邀約信件。 "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  history.TypeName === "Interview"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "time-wrap" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(history.OccurDate) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "text-wrap" },
                                          [_vm._v("結果審核")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "note-wrap" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(history.Status) + " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  history.TypeName === "InterviewResult"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "time-wrap" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(history.OccurDate) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "text-wrap" },
                                          [_vm._v("審核結束")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "note-wrap" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(history.Status) + " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  history.TypeName === "ThanksNotice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "time-wrap" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(history.OccurDate) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "note-wrap" },
                                          [
                                            _vm._v(
                                              " 感謝您在百忙中撥冗前來面試，祝您萬事如意、身體健康。 "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  history.TypeName === "HireNotice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "time-wrap" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(history.OccurDate) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "text-wrap" },
                                          [_vm._v("審核結束-錄取通知")]
                                        ),
                                        _vm._m(2, true),
                                      ]
                                    : _vm._e(),
                                  history.TypeName === "OnboardIntention"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "time-wrap" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(history.OccurDate) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "text-wrap" },
                                          [_vm._v("審核結束-意願回覆")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "note-wrap" },
                                          [
                                            history.Status === "願意報到"
                                              ? [_vm._v(" 您已回覆願意報到 ")]
                                              : [
                                                  _vm._v(
                                                    " 您已回覆無意願報到 "
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                      ]
                                    : _vm._e(),
                                  history.TypeName === "ReportNotice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "time-wrap" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(history.OccurDate) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "text-wrap" },
                                          [_vm._v("審核結束-報到通知")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "note-wrap" },
                                          [
                                            _vm._v(
                                              " 歡迎您加入我們團隊，請依報到程序進行報到。 "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    { staticClass: "button-wrap" },
                                    [
                                      history.TypeName === "WriteResume"
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "btn",
                                              attrs: { type: "button" },
                                              on: { click: _vm.showResume },
                                            },
                                            [_vm._v(" 維護履歷 ")]
                                          )
                                        : _vm._e(),
                                      history.TypeName === "InterviewInvitation"
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "btn",
                                              attrs: {
                                                type: "button",
                                                "data-toggle": "modal",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showInterviewMail(
                                                    history.InterviewId
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 檢視邀約信件 ")]
                                          )
                                        : _vm._e(),
                                      history.TypeName === "ThanksNotice"
                                        ? [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn",
                                                attrs: {
                                                  type: "button",
                                                  "data-toggle": "modal",
                                                },
                                                on: {
                                                  click: _vm.showThankYouMail,
                                                },
                                              },
                                              [_vm._v(" 檢視感謝函 ")]
                                            ),
                                          ]
                                        : _vm._e(),
                                      history.TypeName === "HireNotice"
                                        ? [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn",
                                                attrs: {
                                                  type: "button",
                                                  "data-toggle": "modal",
                                                },
                                                on: {
                                                  click: _vm.showHiringMail,
                                                },
                                              },
                                              [_vm._v(" 檢視錄取信件 ")]
                                            ),
                                            history.TypeName === "HireNotice"
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass: "btn",
                                                    staticStyle: {
                                                      "margin-left": "10px",
                                                    },
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.$router.push(
                                                          `/decline_report/${_vm.MatchId}`
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 回覆報到意願 ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        : _vm._e(),
                                      history.TypeName === "ReportNotice"
                                        ? [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn",
                                                attrs: {
                                                  type: "button",
                                                  "data-toggle": "modal",
                                                },
                                                on: {
                                                  click: _vm.showReportMail,
                                                },
                                              },
                                              [_vm._v(" 檢視報到信件 ")]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ],
                                2
                              ),
                            ])
                          }),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
              ]
            : _vm._e(),
          !_vm.showRecord ? [_vm._m(3)] : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "modal fade bd-example-modal-xl",
          attrs: { id: "mailModal", tabindex: "-1", "data-backdrop": "static" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg",
            },
            [
              _c(
                "div",
                { staticClass: "modal-content" },
                [
                  _vm._m(4),
                  _c("perfect-scrollbar", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "title" }, [
                      _c("h2", [
                        _c("i", {
                          staticClass: "fa fa-briefcase icon1",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Offer Letter"),
                        ]),
                      ]),
                      _c("h4", [_vm._v(_vm._s(_vm.mailContent.Subject))]),
                      _c("div", { staticStyle: { float: "right" } }, [
                        _vm.mailContent.OfferFileGroupId
                          ? _c(
                              "p",
                              {
                                staticClass: "download-file",
                                on: {
                                  click: function ($event) {
                                    return _vm.$common.downloadFileGroup({
                                      fileGuid:
                                        _vm.mailContent.OfferFileGroupId,
                                      fileTitle: "application/pdf",
                                    })
                                  },
                                },
                              },
                              [_vm._v(" 檢視 Offer ")]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _c("div", { staticClass: "form-content" }, [
                      _c("p", {
                        domProps: { innerHTML: _vm._s(_vm.mailContent.Body) },
                      }),
                    ]),
                  ]),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "welcome" }, [
      _c("div", [_vm._v("應徵進度")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "time-wrap" }, [
      _c("strong", [_vm._v("親愛的求職者")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "note-wrap" }, [
      _vm._v(
        " 感謝您參加本公司面試，經主管評核，很榮幸通知您的經歷符合職缺需求，"
      ),
      _c("br"),
      _vm._v(" 請點選下方按鈕回覆報到意願或檢視錄取信件。 "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", [
      _c("div", { staticClass: "notice" }, [
        _c("img", {
          attrs: { src: require("@/assets/img/no_record.png"), alt: "" },
        }),
        _c("p", [_vm._v("您尚未應徵任何職缺")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close text-right",
        staticStyle: { "margin-right": "6px" },
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [
        _c(
          "span",
          { staticStyle: { color: "#fff" }, attrs: { "aria-hidden": "true" } },
          [_vm._v("×")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }